import {
    call,
    put,
    takeLatest
} from 'redux-saga/effects';
import TaxProfile from '../api/TaxProfileApi';
import taxActions from '../actions/tax.actions';
import errorActions from "../actions/error.actions";


function* refreshTaxRecord(action) {
    try {
        const record = yield call(TaxProfile.refreshTaxRecord, action.payload);
        yield put(taxActions.refreshTaxRecordComplete(record));
    } catch (err) {
        if (err.response) {
            yield put(errorActions.showErrorMessage(err.response.data));
        }
        yield put(taxActions.refreshTaxRecordFailed(err));
    }
}

function* fetchOrganizations(action) {
    try {
        const organizations = yield call(TaxProfile.getOrganizations, action.payload);
        yield put(taxActions.getOrganizationsSuccess(organizations));
    } catch (e) {
        yield put(taxActions.getOrganizationsFailed(e));
    }
}

function* consentForPayment(action) {
    try {
        const consentUrl = yield call(TaxProfile.consentForPayment, action.payload);
        yield put(taxActions.consentForPaymentSuccess(consentUrl));
    } catch (err) {
        if (err.response) {
            yield put(errorActions.showErrorMessage(err.response.data));
        }
        yield put(taxActions.consentForPaymentFailed(err));
    }
}

function* fetchTaxInterviewURL(action) {
    try {
        const taxInterview = yield call(TaxProfile.getTaxInterviewURL, action.payload);
        yield put(taxActions.getTaxInterviewURLSuccess(taxInterview));
    } catch (e) {
        yield put(taxActions.getTaxInterviewURLFailed(e));
    }
}

function* fetchTaxRecord(action) {
    try {
        const recordResp = yield call(TaxProfile.getTaxRecord, action.payload);
        if (recordResp.status === 'Error' && recordResp.statusCode !== 404) {
            yield put(errorActions.showErrorMessage(recordResp));
            return;
        }
        const _rec = recordResp.data;
        let params = {};
        if (_rec.profileType) {
            params = {
                profileType: _rec.profileType
            };
            if (_rec.organizationEntity) {
                params.organizationId = _rec.identityId;
            }
            const available = yield call(TaxProfile.getUpdateAvailable, params);
            yield put(taxActions.getUpdateAvailableSuccess(available));
        }
        yield put(taxActions.getTaxRecordSuccess(recordResp));
    } catch (e) {
        yield put(taxActions.getTaxRecordFailed(e));
    }
}

function* retakeInterview(action) {
    try {
        const taxRecord = yield call(TaxProfile.retakeInterview, action.payload);
        yield put(taxActions.retakeInterviewSuccess(taxRecord));
    } catch (e) {
        yield put(taxActions.retakeInterviewFailed(e));
    }
}

function* updateTaxRecord(action) {
    try {
        const taxRecord = yield call(TaxProfile.updateTaxRecord, action.payload);
        yield put(taxActions.updateTaxRecordSuccess(taxRecord));
    } catch (ex) {
        if (ex.response) {
            yield put(errorActions.showErrorMessage(ex.response.data));
        }
        yield put(taxActions.updateTaxRecordFailed(ex));
    }
}

function* getBalancePayable(action) {
    try {
        const payAble = yield call(TaxProfile.getBalancePayable, action.payload);
        yield put(taxActions.getBalancePayableSuccess(payAble));
    } catch (error) {
        yield put(taxActions.getBalancePayableFailed(error));
    }
}

function* getConsent(action) {
    try {
        const resp = yield call(TaxProfile.getConsent, action.payload);
        yield put(taxActions.getConsentSuccess(resp));
    } catch (err) {
        yield put(taxActions.getConsentFailed(err));
    }
}

function* getRecordEmail(action) {
    try {
        const resp = yield call(TaxProfile.getRecordEmail, action.payload);
        yield put(taxActions.getRecordEmailSuccess(resp));
    } catch (err) {
        yield put(taxActions.getRecordEmailFailed(err));
    }
}

function* taxSaga() {
    yield takeLatest(taxActions.TYPES.GET_BALANCE_PAYABLE, getBalancePayable);
    yield takeLatest(taxActions.TYPES.GET_ORGANIZATIONS, fetchOrganizations);
    yield takeLatest(taxActions.TYPES.GET_TAX_INTERVIEW, fetchTaxInterviewURL);
    yield takeLatest(taxActions.TYPES.GET_TAX_RECORD, fetchTaxRecord);
    yield takeLatest(taxActions.TYPES.RETAKE_INTERVIEW, retakeInterview);
    yield takeLatest(taxActions.TYPES.UPDATE_TAX_RECORD, updateTaxRecord);
    yield takeLatest(taxActions.TYPES.GET_CONSENT, getConsent);
    yield takeLatest(taxActions.TYPES.GET_RECORD_EMAIL, getRecordEmail);
    yield takeLatest(taxActions.TYPES.REFRESH_TAX_RECORD, refreshTaxRecord);
    yield takeLatest(taxActions.TYPES.CONSENT_FOR_PAYMENT, consentForPayment);
}

export default taxSaga;
